/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

// "Damage Files" grid column - visible for ALL user types (unlike the CUSTOMER-only Dealer
// Condition column). The count comes from parent.state.damageFilesCountMap, populated once via
// /billing/dealerDamageFilesSummary for the currently loaded rows - that endpoint re-derives
// ownership itself, so a row this user isn't authorized for simply never gets a count here. The
// actual file list + signed URLs are fetched only on click, from the separate, per-row
// /billing/dealerDamageFiles endpoint (parent.onClickViewDamageFiles).
const DamageFilesAction = (props) => {
    const parent = props.context && props.context.componentParent;
    if (!parent) return null;

    const count = (parent.state.damageFilesCountMap || {})[String(props.data._id)] || 0;
    if (!count) return <span className="text-muted">-</span>;

    return (
        <button className="btn btn-outline-danger" style={{ padding: '2px 10px', fontSize: '12px', margin: 0 }}
            onClick={(e) => { e.stopPropagation(); parent.onClickViewDamageFiles(props.data); }}>
            View Files ({count})
        </button>
    );
};

export default DamageFilesAction;
